export class GoogleWorkspaceUser {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "userId",
            "baseName": "userId",
            "type": "string",
            "format": ""
        },
        {
            "name": "primaryEmail",
            "baseName": "primaryEmail",
            "type": "string",
            "format": ""
        },
        {
            "name": "fullName",
            "baseName": "fullName",
            "type": "string",
            "format": ""
        },
        {
            "name": "orgUnitPath",
            "baseName": "orgUnitPath",
            "type": "string",
            "format": ""
        },
        {
            "name": "suspended",
            "baseName": "suspended",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "archived",
            "baseName": "archived",
            "type": "boolean",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return GoogleWorkspaceUser.attributeTypeMap;
    }
    constructor() {
    }
}
